export default "/app/themes/macleod/public/images/play-icon.svg?46d42a9c538271b34bf970db9796c023";